(function () {
    'use strict';

    Directives.AttachmentDirective = function AttachmentDirective() {
        // @ngInject
        function AttachmentDirectiveControllerCtor($scope, $injector) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'AttachmentDirectiveController';

            this.attachmentName = this.attachment.file_name || ((this.attachment.name || this.attachment.asset_name) + '.' + this.attachment.file_type);
        }

        var AttachmentDirectiveController = Class(Controllers.BaseController, {
            constructor: AttachmentDirectiveControllerCtor,

            createDownloadableLink: function createDownloadableLink() {
                if(this.attachment.cloudinary_public_id != null) {
                    var result = this.attachment.url.split('/upload/');
                    return result.join('/upload/fl_attachment/');
                }
                else {
                    return this.attachment.url;
                }
            },

            createDownloadSaveAsName: function createDownloadSaveAsName() {
                return this.duringUpload ? '' : this.attachment.url.substring(decodeURIComponent(this.attachment.url).lastIndexOf('/')+1);
            },

            getIconForFile: function getIconForFile() {


                var url = "//res.cloudinary.com/honeybook/image/upload/v1502008386/system_web/rebranding/file-default.svg";

                if (this.attachmentName.match(/xlsx?$/)) {
                    url = "//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_xls.svg";
                }
                else if (this.attachmentName.match(/docx?$/)) {
                    url = "//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_doc.svg";
                }
                else if (this.attachmentName.match(/pdf$/)) {
                    url = "//res.cloudinary.com/honeybook/image/upload/v1501764252/system_web/rebranding/file_icon_pdf.svg";
                }

                return url;
            },
        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/common/ui_components/attachment/attachment_directive_template.html',
            controller: AttachmentDirectiveController,
            controllerAs: 'attachmentVm',
            bindToController: true,
            scope: {
                attachment: '=',

                duringUpload: '=?',

                deletable: '=?',
                onDelete: '&?'
            }
        };
    };

}());

